import React, { useCallback, useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import { handleDateTimeToDate } from '../services/date';
import './Print.css';

function PrintPage() {
    const CACHED_NAME = 'committesAndMembers';
    const CACHED_SCHEMA = [
        {
          "id": 0,
          "name": "string",
          "term": "string",
          "appointments": "string",
          "meetingSchedule": "string",
          "meetingLocation": "string",
          "website": "string",
          "committeeMembers": [
            {
              "id": 0,
              "committeeID": 0,
              "personID": 0,
              "yearAppointed": 0,
              "membershipExpires": "2019-09-20T15:14:05.195Z",
              "membershipType": "string",
              "person": {
                "id": 0,
                "name": "string",
                "personData": {
                  "id": 0,
                  "personID": 0,
                  "data": "string"
                }
              }
            }
          ]
        }
    ];
    //useful for testing
    //localStorage.removeItem(CACHED_NAME);
    const CACHED_ITEM = JSON.parse(localStorage.getItem(CACHED_NAME)) || CACHED_SCHEMA;
    
    //Data
    const [committees, setCommittees] = useState(CACHED_ITEM);
    //Components
    const { enqueueSnackbar } = useSnackbar();
    //Services (should move to service) along with other ajax helpers
    const handleError = useCallback((error) => { enqueueSnackbar(error.message, { variant: 'error' }); },[enqueueSnackbar]);
    
    useEffect(() => {
        fetch('https://api2.auburnalabama.org/committee/all', { credentials: 'include' })
            .then((response) => { if (response.ok) return response.json(); else throw new Error(response.statusText)})
            .then((committees) => { setCommittees(committees); })
            .catch(handleError);
    }, [handleError]);

    return (
        <section id="printPage">
            <header className="main">
                <h2>CITY OF AUBURN BOARDS AND COMMISSIONS</h2>
                <small>Term expires on date shown opposite name of member</small>
            </header>
            {committees.map((committee) => {
                return (
                    <section key={committee.id}>
                        <header><h2>{committee.name}</h2></header>
                        <table><tbody>
                            {committee.committeeMembers && committee.committeeMembers.map((member) => {
                                return (<tr key={member.id}>
                                    <td>{member.person.name}</td>
                                    <td>{`(${(''+member.yearAppointed).slice(-2)})`}</td>
                                    <td>{handleDateTimeToDate(member.membershipExpires)}</td>
                                    <td>{member.membershipType}</td>
                                </tr>)
                            })}    
                        </tbody></table>
                        <div>{`${committee.appointments} ${committee.term}`}</div>
                        <div>{`Meets: ${committee.meetingSchedule}${(committee.meetingLocation ? ' at ' + committee.meetingLocation : '')}`}</div>
                    </section>
                )
            })}
        </section>
    )
}

export { PrintPage };